import { render, staticRenderFns } from "./EduLayout.vue?vue&type=template&id=80d3d532&scoped=true"
import script from "./EduLayout.vue?vue&type=script&lang=js"
export * from "./EduLayout.vue?vue&type=script&lang=js"
import style0 from "./EduLayout.vue?vue&type=style&index=0&id=80d3d532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d3d532",
  null
  
)

export default component.exports